import { render } from "./Farming.vue?vue&type=template&id=54dc2ff6"
import script from "./Farming.vue?vue&type=script&lang=js"
export * from "./Farming.vue?vue&type=script&lang=js"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__